export const SUBSCRIPTION_HEALTH = {

  HEALTHY: 'healthy',

  WARNING: 'warning',

  EXPIRED: 'expired',

  PENDING: 'pending',

  SUSPENDED: 'suspended',

  BLOCKED: 'blocked',

} as const;

export type SubscriptionHealthType =
typeof SUBSCRIPTION_HEALTH[
  keyof typeof SUBSCRIPTION_HEALTH
];